import { render } from "./CustomSelectOneCategoryType.vue?vue&type=template&id=70e553c0"
import script from "./CustomSelectOneCategoryType.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneCategoryType.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__